import trashIcon from '@/assets/ic_trash.svg'
import editIcon from '@/assets/krea/ic_edit.svg'
import commentIcon from '@/assets/krea/ic_comment.svg'
import worldIcon from '@/assets/ic_world.svg'
import userAddIcon from '@/assets/ic_user_add.svg'
import changeIcon from '@/assets/ic_change.svg'
import unpublishIcon from '@/assets/ic_circle_cross.svg'
import publishIcon from '@/assets/ic_checkbox_rounded-active.svg'

export const kreaCollaborativePermissions = {
  comment: 1,
  edit: 2,
  owner: 3,
  none: 0
}

export const kreaCollaborativePermissionsIcons = {
  none: trashIcon,
  comment: commentIcon,
  edit: editIcon,
  owner: null
}

export const authorTypes = {
  external: 1,
  schoolGroup: 2,
  schoolGroupCoAuthor: 3
}

export const kreaCreationsFilter = {
  own: 1,
  collaborations: 2
}

export const programCardOptions = [
  { label: 'addLanguage', icon: worldIcon },
  { label: 'addCollaborators', icon: userAddIcon },
  { label: 'changeContentType', icon: changeIcon },
  { label: 'unpublish', icon: unpublishIcon },
  { label: 'publish', icon: publishIcon },
  { label: 'editKeywords', icon: editIcon },
  { label: 'delete', icon: trashIcon }
]
